import { handerImageURL } from './file.js'
import { draggable } from '../directives/draggable.js'
/**
 * 设置图片URL
 * @param {*} el
 * @param {*} binding
 */
const setImgURL = (el, binding) => {
  const { w, h, q, compress } = el.dataset
  const src = binding.value

  const loadImg = url => {
    const img = new Image()
    img.onload = () => {
      el.src = url
    }
    img.src = url
  }
  if (!src) {
    return ''
  }

  const isCompress = +compress !== 0 && src.indexOf('x-oss-process=') === -1

  const imgSrc = isCompress ? handerImageURL(src, { w, h, q }) : src
  loadImg(imgSrc)
}
export const vLazyLoad = {
  mounted(el, binding) {
    const observe = new IntersectionObserver(
      entries => {
        entries.forEach(item => {
          const { isIntersecting } = item
          if (isIntersecting) {
            observe.unobserve(el)
            setImgURL(el, binding)
          }
        })
      },
      {
        threshold: 0 //进入到可视区交界就开始观察
      }
    )
    observe.observe(el) // 使用observe上的observe方法观察这个dom元素
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      setImgURL(el, binding)
    }
  }
}
export const installDirective = app => {
  // 自定义按钮全选
  app.directive('btnlimit', {
    mounted: (el, binding) => {
      // el 当前绑定的元素 binding.value指令的绑定值
      const value = sessionStorage.getItem('permission_button')
      let permissionObj = value && JSON.parse(value)
      if (!permissionObj[binding.value]) {
        el.parentNode.removeChild(el)
      }
    }
  })
  app.directive('lazyLoad', vLazyLoad)
  app.directive('draggable', draggable)
}
